// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1XWwM","col":"CardReaderDesc_col__3Aufq","label":"CardReaderDesc_label__CGJ4O"};